import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    switchPreview: {
        justifyContent: "center",
        pointerEvents: "none",
        alignItems: "center"
    },
    chevron: {
        justifyContent: "center",
        alignItems: "center"
    }
});
export default stylesheet;
